import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "q-card column justify-between",
  style: {"width":"1200px","max-width":"80vw","flex-wrap":"nowrap"}
}
const _hoisted_2 = { class: "q-ma-md q-mb-lg" }
const _hoisted_3 = { class: "row items-start q-mt-lg" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "text-weight-bold block" }
const _hoisted_6 = { class: "text-weight-bold block" }
const _hoisted_7 = { class: "text-weight-bold block" }
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Invoice description: ")
const _hoisted_10 = { class: "row items-start" }
const _hoisted_11 = { class: "col-10 offset-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Invoice channel:")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Invoice email:")
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-1 offset-11" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_revoke_invoice = _resolveComponent("revoke-invoice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.invoice.customer.address.street), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.invoice.customer.address.zip) + " " + _toDisplayString(_ctx.invoice.customer.address.city), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.invoice.customer.address.countryCode), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_q_list, {
            class: "q-mb-lg",
            dense: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceBusinessInfo, (invoiceItem, index) => {
                return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(invoiceItem.label) + ":", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(invoiceItem.value), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.invoiceDescription), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_q_table, {
        columns: _ctx.productColumns,
        rows: _ctx.invoice.lines,
        "row-key": "name",
        flat: "",
        "hide-bottom": "",
        "table-class": "product-table",
        class: "q-mb-lg"
      }, null, 8, ["columns", "rows"]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_q_list, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.invoice.delivery.policy.type), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              ( _ctx.invoice.delivery.policy.type  === _ctx.DeliveryPolicyType.Email)
                ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoice.delivery.policy.email), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.invoice.delivery.policy.type === _ctx.DeliveryPolicyType.Electronic)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.invoiceDeliveryOperator, (operatorItem, index) => {
                    return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(operatorItem.label) + ":", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(operatorItem.value), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true),
              (_ctx.invoice.delivery.policy.type === _ctx.DeliveryPolicyType.Mail)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.invoiceDeliveryAddress, (addressItem, index) => {
                    return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(addressItem.label) + ":", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(addressItem.value), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_list, {
            dense: "",
            class: "q-mt-xl"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceTotalPayment, (invoiceTotalItem, index) => {
                return (_openBlock(), _createBlock(_component_q_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "col-4 text-right text-h5 text-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(invoiceTotalItem.label) + ":", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, { class: "q-pl-lg text-h5 text-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(invoiceTotalItem.value), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.invoice.status === _ctx.InvoiceStatus.Failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_revoke_invoice, {
                invoiceId: _ctx.invoice.identifier,
                updateCallback: _ctx.updateCallback
              }, null, 8, ["invoiceId", "updateCallback"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}